import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  const catName = categories.find((c) => c.slug === comic.category)?.name ?? comic.category;
  return (
    <article className="group flex flex-col rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-colors duration-300">
      <Link
        to={`/comic/${comic.id}`}
        className="relative block overflow-hidden"
        aria-label={`阅读《${comic.title}》`}
      >
        <div className="w-full aspect-[3/4] overflow-hidden bg-background-100">
          <img
            src={comic.cover}
            alt={`${comic.title} 漫画封面`}
            title={`${comic.title} 漫画全集免费阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute top-2 left-2 rounded-md bg-primary-500 text-background-50 text-xs font-medium px-2 py-0.5">
          {catName}
        </span>
        {comic.featured && (
          <span className="absolute top-2 right-2 rounded-md bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5">
            主编力荐
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-3 pb-2 pt-6">
          <p className="text-background-50 text-sm font-medium truncate">{comic.lastChapter}</p>
        </div>
      </Link>
      <div className="p-3 md:p-4 flex flex-col gap-2 flex-1">
        <h3 className="font-heading text-base md:text-lg text-foreground-900 truncate">
          <Link to={`/comic/${comic.id}`} className="hover:text-primary-600 transition-colors">
            {comic.title}
          </Link>
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {comic.rating.toFixed(1)}
          </span>
          <span>{comic.status}</span>
        </div>
        <div className="mt-auto flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {comic.views}
          </span>
          <span className="text-primary-600">共{comic.totalChapters}话</span>
        </div>
      </div>
    </article>
  );
}